var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormBgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 692,
    height: 964,
    viewBox: "0 0 692 964",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_119",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 0,
    width: 493,
    height: 964
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199 20C199 8.9543 207.954 0 219 0H672C683.046 0 692 8.95431 692 20V944C692 955.046 683.046 964 672 964H219C207.954 964 199 955.046 199 944V20Z",
    fill: "url(#paint0_linear_1_119)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_119)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M578.603 -1.99997L229.5 964.5L594.397 964.5L943.5 -1.99994L578.603 -1.99997Z",
    fill: "#F5F5F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_119",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 519,
    height: 964
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.9543 8.95431 0 20 0H499C510.046 0 519 8.95431 519 20V944C519 955.046 510.046 964 499 964H20C8.95431 964 0 955.046 0 944V20Z",
    fill: "url(#paint1_linear_1_119)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_119)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M228.985 -8.5034e-05L-123 963L151.515 963L503.5 -6.10352e-05L228.985 -8.5034e-05Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_119",
    x1: 269.531,
    y1: 46.5,
    x2: 911.603,
    y2: 768.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#61B562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_119",
    x1: 74.2511,
    y1: 46.5,
    x2: 711.641,
    y2: 801.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#61B562"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBgShape);
export default __webpack_public_path__ + "static/media/formBgShape.693639bc88190165cc41cbc4d7345c21.svg";
export { ForwardRef as ReactComponent };